export function getAsset(currentVersion, filePath) {
  return `https://static.parastorage.com/services/bookings-viewer-script/${currentVersion}/assets/${filePath}`;
}
